import * as Types from '@frameio/graphql-client/generated/types';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import gql from 'graphql-tag';
import { CompleteAccountUser } from '../../../../../_global/fragments/generated/CompleteAccountUser';

import { useQuery, useLazyQuery, useMutation, useFragment, useSubscription } from '@apollo/client';
import type { QueryHookOptions, LazyQueryHookOptions, MutationHookOptions, SubscriptionHookOptions, UseFragmentOptions } from '@apollo/client';

export type GetAccountUsersQueryVariables = Types.Exact<{
  accountId: Types.Scalars['ID']['input'];
  orderBy?: Types.InputMaybe<Array<Types.AccountUserOrder>>;
  page: Types.PageInput;
  filter?: Types.InputMaybe<Types.AccountUsersFilter>;
}>;


export type GetAccountUsersQuery = { __typename?: 'Query', account?: { __typename?: 'Account', id: string, accountUsers?: { __typename?: 'AccountUserConnection', totalCount: number, nodes: Array<{ __typename?: 'AccountUser', id: string, avatarColor?: Types.AvatarColor | null, accountUserType?: Types.AccountUserTypeEnum | null, deactivatedAt?: string | null, email?: string | null, accountJoinedVia: Types.AccountUserJoinedViaEnum, deletedAt?: string | null, displayAccountUserType?: string | null, displayName?: string | null, displayStatus?: string | null, inviteEmailAddress?: string | null, isDeactivated: boolean, isPending: boolean, licenseType?: Types.AccountUserLicenseTypeValue | null, status?: Types.AccountUserStatusEnum | null, userLastActiveAt?: string | null, name?: string | null, profileImageUrl?: string | null, timezone?: any | null, userId?: string | null, insertedAt?: string | null, profile?: { __typename?: 'UserProfile', jobTitle?: string | null, organizationName?: string | null } | null }>, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null, hasNextPage: boolean } } | null, unfilteredAccountUsers?: { __typename?: 'AccountUserConnection', totalCount: number } | null } | null };


export const GetAccountUsers = /*#__PURE__*/ gql`
    query GetAccountUsers($accountId: ID!, $orderBy: [AccountUserOrder!], $page: PageInput!, $filter: AccountUsersFilter) {
  account(by: {id: $accountId}) {
    id
    accountUsers(orderBy: $orderBy, page: $page, filter: $filter) {
      nodes {
        ...CompleteAccountUser
      }
      pageInfo {
        endCursor
        hasNextPage
      }
      totalCount
    }
    unfilteredAccountUsers: accountUsers(
      page: {first: 0}
      filter: {accountUserIsDeleted: false}
    ) {
      totalCount
    }
  }
}
    ${CompleteAccountUser}` as unknown as DocumentNode<GetAccountUsersQuery, GetAccountUsersQueryVariables>;

          

          export const useGetAccountUsersQuery = (options?:QueryHookOptions<GetAccountUsersQuery, GetAccountUsersQueryVariables>) => useQuery(GetAccountUsers, options);

          

          export type GetAccountUsersQueryOptions = QueryHookOptions<GetAccountUsersQuery, GetAccountUsersQueryVariables>;

          

          export const useGetAccountUsersLazyQuery = (options?:LazyQueryHookOptions<GetAccountUsersQuery, GetAccountUsersQueryVariables>) => useLazyQuery(GetAccountUsers, options);

          

          export type GetAccountUsersQueryResult = ReturnType<typeof useGetAccountUsersQuery>;

          
